'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowCompare = require('./utils/shallowCompare');

var _shallowCompare2 = _interopRequireDefault(_shallowCompare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Element = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Element, _Component);

  function Element(props, context) {
    (0, _classCallCheck3.default)(this, Element);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    _this.state = {};


    _this.value = _this.getOriginalValue(props, context);
    return _this;
  }

  Element.prototype.componentDidMount = function componentDidMount() {
    var parent = this.getParent();
    // I am form
    if (!parent) {
      return;
    }

    parent.registerChild(this, this.props.name);
  };

  Element.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var sameChildren = nextProps.sameChildren;

    var form = this.getForm();

    if (sameChildren === true || typeof sameChildren === 'undefined' && form.props.sameChildren === true) {
      var sameProps = (0, _shallowCompare2.default)(this.props, nextProps, ['children']);
      if (!sameProps) {
        return true;
      }

      var sameState = (0, _shallowCompare2.default)(this.state, nextState, []);
      if (!sameState) {
        return true;
      }

      return false;
    }

    return true;
  };

  Element.prototype.componentWillUnmount = function componentWillUnmount() {
    var parent = this.getParent();
    // I am form
    if (!parent) {
      return;
    }

    parent.unregisterChild(this, this.props.name);
  };

  Element.prototype.getIndexes = function getIndexes() {
    return this.getParent().getIndexes();
  };

  Element.prototype.getTotals = function getTotals() {
    return this.getParent().getTotals();
  };

  Element.prototype.getOriginalValue = function getOriginalValue(props, context) {
    var name = props.name;
    var fieldset = context.fieldset;

    if (!fieldset) {
      return undefined;
    }

    return fieldset.getChildValue(name);
  };

  Element.prototype.getValue = function getValue() {
    return this.value;
  };

  Element.prototype.getParent = function getParent() {
    return this.context.fieldset;
  };

  Element.prototype.getPath = function getPath() {
    var name = this.props.name;

    return this.getPathByName(name);
  };

  Element.prototype.getPathByName = function getPathByName(name) {
    var parent = this.getParent();
    if (!parent) {
      return undefined;
    }

    return parent.buildPath(name);
  };

  Element.prototype.getForm = function getForm() {
    var parent = this.getParent();
    if (!parent) {
      return undefined;
    }

    return parent.getForm();
  };

  Element.prototype.setValue = function setValue(value) {
    var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
    var notifyChildren = arguments[2];
    var currentValue = this.value;

    if (currentValue === value) {
      return;
    }

    this.value = value;

    if (notifyChildren) {
      this.forceUpdate();
      return;
    }

    this.notifyParent(value, component);

    if (component === this) {
      this.forceUpdate();
    }
  };

  Element.prototype.replaceChildren = function replaceChildren(children) {
    return this.getParent().replaceChildren(children);
  };

  Element.prototype.originalValueChanged = function originalValueChanged() {
    var value = this.getOriginalValue(this.props, this.context);
    this.setValue(value, this, true);
  };

  Element.prototype.notifyParent = function notifyParent(value, component) {
    var name = this.props.name;

    var parent = this.getParent();

    // form has no parent
    if (parent) {
      parent.setChildValue(name, value, component);
    }
  };

  Element.prototype.render = function render() {
    return null;
  };

  return Element;
}(_react.Component), _class.propTypes = {
  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
}, _class.contextTypes = {
  fieldset: _propTypes2.default.object.isRequired
}, _temp);
exports.default = Element;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Element.js
 ** module id = 80
 ** module chunks = 0
 **/